import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WeightFormatPipe } from 'app/pipes/weight-format.pipe';
import { OrderTableComponent } from '../order-table/order-table.component';
import { calculateTotalWeight } from 'app/utils/weigth';
import { OrderAttributes } from '@albatrosdeveloper/ave-models-package';
import { RefreshContext } from '../../interfaces/refresh-context.interface';

@Component({
  selector: 'app-unified-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCheckboxModule,
    WeightFormatPipe,
    OrderTableComponent
  ],
  templateUrl: './unified-table.component.html',
  styleUrl: './unified-table.component.scss'
})
export class UnifiedTableComponent {
  @Input() unifiedOrdersData: OrderAttributes[];
  @Input() loadCalculationMode: string| undefined;
  @Input() UMPActive: boolean = false;

  @Output() ordersJoined = new EventEmitter<RefreshContext>();
  @Output() onExpandUnified = new EventEmitter<OrderAttributes>();

  displayedColumns: string[] = ['det','route', 'quantity', 'weight'];
  dataSource = new MatTableDataSource<OrderAttributes>();

  selectedUnifiedOrderItem: OrderAttributes | null = null;

  constructor(
    
  ) { 
  }

  ngOnInit(): void {
    if (this.unifiedOrdersData) {
      this.dataSource.data = this.unifiedOrdersData;
      this.filterData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.unifiedOrdersData.currentValue) {
      this.dataSource.data = changes.unifiedOrdersData.currentValue;
      this.filterData();
    }
  }

  filterData(){
    this.dataSource.data.forEach((row) => {
      (row as any).weight = this.calculateTotalGlobalWeight(row.sourceTransactions as OrderAttributes[] || []);
    })
  }

  private calculateTotalGlobalWeight(orders: OrderAttributes[]): string {
    let totalWeight = 0;

    if(!Array.isArray(orders)) return '0.000';

    orders.forEach(order => {
      totalWeight += parseFloat(calculateTotalWeight(order, this.loadCalculationMode));
    });
    return `${totalWeight.toFixed(3)}`;
  }

  changeSort(event: { active: string; direction: 'asc' | 'desc' }) {
    if(this.dataSource.data.length === 0) return;
    const direction = event.direction === 'asc' ? 'ASC' : 'DESC';
    //this.onSortChange.emit({ active: this.getSortField(event.active), direction });
  }

  closeDetails(): void {
    this.selectedUnifiedOrderItem = null;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedUnifiedOrderItem && this.selectedUnifiedOrderItem?.serial === order.serial) {
      this.closeDetails();
      return;
    }

    this.selectedUnifiedOrderItem = order;

    // Emitir evento para que el componente padre cargue los sourceTransactions bajo demanda
    this.onExpandUnified.emit(order);
  }
}
